import { ContainerModule } from 'inversify';
import DeliveryScheduleRepository from 'src/features/checkout/data/repositories/DeliveryScheduleRepository';
import DeliveryScheduleService from 'src/features/checkout/data/service/DeliveryScheduleService';
import { DeliveryScheduleRepositoryInterface } from 'src/features/checkout/domain/repositories/DeliveryScheduleRepository.interface';
import { DeliveryScheduleServiceInterface } from 'src/features/checkout/domain/services/DeliveryScheduleService.interface';
import GetDeliveryScheduleConfigUseCase from 'src/features/checkout/domain/useCases/GetDeliveryScheduleConfig';
import DiscountCouponRepository from 'src/features/discountCoupons/data/DiscountCouponsRepository';
import DiscountCouponService from 'src/features/discountCoupons/data/service/DiscountCouponService';
import { DiscountCouponServiceInterface } from 'src/features/discountCoupons/data/service/DiscountCouponService.types';
import { DiscountCouponRepositoryInterface } from 'src/features/discountCoupons/domain/DiscountCouponsRespository.types';

export const checkoutBindings = new ContainerModule((bind) => {
  // Services
  bind<DiscountCouponServiceInterface>(DiscountCouponService).to(
    DiscountCouponService
  );
  bind<DeliveryScheduleServiceInterface>(DeliveryScheduleService).to(
    DeliveryScheduleService
  );

  // Repositories
  bind<DiscountCouponRepositoryInterface>(DiscountCouponRepository).to(
    DiscountCouponRepository
  );
  bind<DeliveryScheduleRepositoryInterface>(DeliveryScheduleRepository).to(
    DeliveryScheduleRepository
  );

  // Use cases
  bind<GetDeliveryScheduleConfigUseCase>(GetDeliveryScheduleConfigUseCase).to(
    GetDeliveryScheduleConfigUseCase
  );
});
